import React from 'react';
import { Avatar, SimpleCell, Text } from '@vkontakte/vkui';
import { Icon28UserCircleOutline } from '@vkontakte/icons';

function playerName(player) {
  return [player?.first_name, player?.last_name].filter(Boolean).join(' ') || player?.name || 'Ученик';
}

function RatingAvatar({ player }) {
  if (player?.avatar_url) {
    return <Avatar size={40} src={player.avatar_url} />;
  }

  return <Avatar size={40}><Icon28UserCircleOutline /></Avatar>;
}

export function RatingEntryCard({ item, currentPlayerID, compact = false }) {
  const isCurrent = Number(item.player.vk_user_id) === Number(currentPlayerID);
  const place = item.place || item.position || item.rank || '';

  return (
    <SimpleCell
      Component="a"
      href={`https://vk.com/id${item.player.vk_user_id}`}
      target="_blank"
      rel="noreferrer"
      before={(
        <div className="flex shrink-0 items-center gap-3">
          <span className={`block shrink-0 whitespace-nowrap text-right text-[var(--vkui--color_text_secondary)] tabular-nums ${compact ? 'w-[48px]' : 'w-7'}`}>
            {place || '–'}
          </span>
          <RatingAvatar player={item.player} />
        </div>
      )}
      after={(
        <span className="block w-[76px] shrink-0 whitespace-nowrap text-right font-medium tabular-nums">
          {item.rating}
        </span>
      )}
      subtitle={isCurrent ? 'Это вы' : undefined}
      multiline
    >
      {playerName(item.player)}
    </SimpleCell>
  );
}
